<template>
  <OnboardingTooltip ref="tooltip" />
</template>

<script setup lang="ts">
  import { useTemplateRef } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { OnboardingTooltip } from '@/shared/ui';

  import {
    wasFavoritesOnboardingShown,
    setFavoritesOnboardingShown,
  } from '../lib';
  import {
    FAVORITES_SEARCH_BUTTON_ID,
    FAVORITES_CARD_BUTTON_SELECTOR,
  } from '../config';

  const { t } = useI18n();
  const tooltip = useTemplateRef('tooltip');

  function startTicketStep() {
    tooltip.value?.start({
      targetSelector: FAVORITES_CARD_BUTTON_SELECTOR,
      qaId: 'favoritesOnboarding.ticket',
      title: t('favoritesOnboarding.ticket.title'),
      tooltipIndents: {
        top: 10,
        left: -120,
      },
      action: {
        text: t('favoritesOnboarding.ticket.action'),
        callback: () => undefined,
      },
    });
  }

  function start() {
    if (wasFavoritesOnboardingShown()) {
      return;
    }

    setTimeout(() => {
      tooltip.value?.start({
        targetSelector: `#${FAVORITES_SEARCH_BUTTON_ID}`,
        qaId: 'favoritesOnboarding.search',
        title: t('favoritesOnboarding.search.title'),
        tooltipIndents: {
          top: 10,
          left: -180,
        },
        tooltipStyles: {
          width: '270px',
        },
        action: {
          text: t('favoritesOnboarding.search.action'),
          callback: startTicketStep,
        },
        onShowCallback: setFavoritesOnboardingShown,
      });
    }, 1000);
  }

  defineExpose({ start });
</script>
